import { api } from '@/lib/api';
import { useApiData } from '@/lib/useApi';
import type { AnalyticsOverview } from '@/lib/types';

export default function KpiCards() {
  const { data, loading, error } = useApiData<AnalyticsOverview>(() => api.analyticsOverview());

  const cards = [
    { id: 'team', title: 'Total Team', value: data?.totalCounselors ?? 0, sub: 'Owner, managers & staff', icon: 'ri-team-line', bg: 'bg-blue-50', iconBg: 'bg-blue-100', iconColor: 'text-blue-600' },
    { id: 'students', title: 'Total Students', value: data?.totalStudents ?? 0, sub: `${data?.studentsThisMonth ?? 0} added this month`, icon: 'ri-graduation-cap-line', bg: 'bg-teal-50', iconBg: 'bg-teal-100', iconColor: 'text-teal-600' },
    { id: 'leads', title: 'Active Leads', value: data?.activeLeads ?? 0, sub: `${data?.followUpsToday ?? 0} follow-ups due today`, icon: 'ri-focus-3-line', bg: 'bg-amber-50', iconBg: 'bg-amber-100', iconColor: 'text-amber-600' },
    { id: 'appointments', title: 'Appointments Today', value: data?.appointmentsToday ?? 0, sub: 'Scheduled for today', icon: 'ri-calendar-check-line', bg: 'bg-purple-50', iconBg: 'bg-purple-100', iconColor: 'text-purple-600' },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {cards.map((card) => (
        <div key={card.id} className={`${card.bg} rounded-xl p-5 border border-white`}>
          <div className="flex items-start justify-between">
            <div>
              <p className="text-xs font-medium text-gray-500 mb-1">{card.title}</p>
              <p className="text-3xl font-bold text-[#3C3C3C]">{loading ? '—' : card.value}</p>
              <p className="text-xs text-gray-500 mt-1">{loading ? 'Loading…' : card.sub}</p>
            </div>
            <div className={`w-11 h-11 flex items-center justify-center rounded-xl ${card.iconBg}`}>
              <i className={`${card.icon} text-xl ${card.iconColor}`} />
            </div>
          </div>
          <div className="mt-3 pt-3 border-t border-white/60">
            <span className="text-xs text-gray-500">{error ? 'Unable to load metrics' : 'Live from your workspace'}</span>
          </div>
        </div>
      ))}
    </div>
  );
}
